import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('sqlEditor');
const type = createActionType('sqlEditor');

export const CREATE_SQL_VIEW = apiType('CreateSqlView');
export const UPDATE_SQL_VIEW = apiType('UpdateSqlView');
export const SAVE_SQL_VIEW = type('SaveSqlView');

export const CLOSE_SQL_EDITOR = type('CloseSqlEditor');

export const PREVIEW_SQL = type('PreviewSql');
